import React, { PropTypes } from 'react'
import SectionText from '../presentational/SectionText';
import Scroll from 'react-scroll';
import NavButton from '../presentational/NavButton';
import data from '../../core/data';

import bpeelLogo from '../../images/phyto/bpeel-b-logo.png';
import cpeelLogo from '../../images/phyto/cpeel-c-logo.png';
import ppeelLogo from '../../images/phyto/ppeel-p-logo.png';

import {Easer} from 'functional-easing';
import { Track, TrackedDiv, TrackDocument } from 'react-track';
import { topTop, topBottom, centerCenter, topCenter, bottomBottom, bottomTop,
        getDocumentRect, getDocumentElement, calculateScrollY } from 'react-track/tracking-formulas';
import {tween, combine} from 'react-imation';
import {rgb, rgba, scale, rotate,
        px, percent, translate3d} from 'react-imation/tween-value-factories';

const easeOutBounce = new Easer().using('out-bounce');

const intro = data.index.intro;

const IntroContainer = (props) => {
  const cpeelIntro = data.index.intro.cpeel;
  const bpeelIntro = data.index.intro.bpeel;
  const ppeelIntro = data.index.intro.ppeel;
  return (
    <section id="intro">
      <TrackDocument formulas={[getDocumentElement, getDocumentRect, calculateScrollY,
      topTop, topBottom, topCenter, centerCenter]}>
        {(documentElement, documentRect, scrollY, topTop,
        topBottom, topCenter, centerCenter, bottomBottom, bottomTop) =>
          <div className="container">
            <Track component="div" className="header" formulas={[topBottom, centerCenter]}>
              {(DIV,posTopBottom,posCenterCenter) =>
                <DIV
                  style={tween(scrollY, {
                    [posTopBottom+50]: { transform: translate3d(0, 0, 0), opacity: 0 },
                    [posTopBottom+250]: { transform: translate3d(0, 0, 0), opacity: 1 }
                  })}>
                  <h1>Herbal Aktiv Peel</h1>
                  <h2>New skin in just days</h2>
                  <p>Which treatment is right for me</p>
                </DIV>
              }</Track>
            <div className="row">
              {/* CPEEL */}
              <Track component="div" className="col-md-4 logo" formulas={[topBottom, topCenter, centerCenter]}>
                {(DIV, posTopBottom, posTopCenter, posCenterCenter) =>
                  <DIV
                    style={tween(scrollY, {
                      [posTopCenter-50]: { transform: translate3d(-100, 0, 0), opacity: 0 },
                      [posTopCenter+100]: { transform: translate3d(0, 0, 0), opacity: 1 }
                    })}>
                    <Scroll.Link
                      to="treatment"
                      smooth={ true }
                      duration={ 600 }
                    >
                      <img src={ cpeelLogo } alt="Corrective Peel Logo" />
                      <h3>Corrective Peel</h3>
                    </Scroll.Link>
                    <p>{ cpeelIntro }</p>
                    <Scroll.Link
                      to="treatment"
                      smooth={ true }
                      duration={ 600 }
                    >
                      <p className="learn-more">Learn More</p>
                    </Scroll.Link>
                  </DIV>
                }</Track>

              {/* BPEEL */}
              <Track component="div" className="col-md-4 logo" formulas={[topBottom, topCenter, centerCenter]}>
                {(DIV, posTopBottom, posTopCenter, posCenterCenter) =>
                  <DIV
                    style={tween(scrollY, {
                      [posTopCenter-50]: { transform: translate3d(0, -100, 0), opacity: 0 },
                      [posTopCenter+100]: { transform: translate3d(0, 0, 0), opacity: 1 }
                    })}>
                    <NavButton path="b-peel">
                      <img src={ bpeelLogo } alt="Beauty Peel Logo" />
                      <h3>Beauty Peel</h3>
                    </NavButton>
                    <p>{ bpeelIntro }</p>
                    <NavButton path="b-peel">
                      <p className="learn-more">Learn More</p>
                    </NavButton>
                  </DIV>
                }</Track>

              {/* PPEEL */}
              <Track component="div" className="col-md-4 logo" formulas={[topBottom, topCenter, centerCenter]}>
                {(DIV, posTopBottom, posTopCenter, posCenterCenter) =>
                  <DIV
                    style={tween(scrollY, {
                      [posTopCenter-50]: { transform: translate3d(100, 0, 0), opacity: 0 },
                      [posTopCenter+100]: { transform: translate3d(0, 0, 0), opacity: 1 }
                    })}>
                    <NavButton path="p-peel">
                      <img src={ ppeelLogo } alt="Phyto Peel Logo" />
                      <h3>Phyto Peel</h3>
                    </NavButton>
                    <p>{ ppeelIntro }</p>
                    <NavButton path="p-peel">
                      <p className="learn-more">Learn More</p>
                    </NavButton>
                  </DIV>
                }</Track>
            </div>
          </div>
        }</TrackDocument>
    </section>
  )
}

export default IntroContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/IntroContainer.jsx
 **/